module.exports = __webpack_public_path__ + "assets/img/Progress_bg.388faaaf.png";